import React from 'react'
import { PreLoginKcRealmVO } from '@repo/types/'
import { Controller, FieldError } from 'react-hook-form'
import { useStageRealm } from '../hooks'
import { STAGES } from '../utils'
import { stageRealmVariants } from '../styles'
import { Button, Hint, Select } from '@tecsinapse/cortex-react'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { mapRealmAlias } from '@repo/core'

interface StageRealmProps {
  options: PreLoginKcRealmVO[]
  setStage: (stage: string) => void
}

const { container, realmSelection, choseRealmToAccessApp, iconHint, containerButton } = stageRealmVariants()

const StageRealm = ({ options, setStage }: StageRealmProps) => {
  const { form, redirect } = useStageRealm()

  const getFieldErrorMessage = (error: FieldError) => {
    if (error.type === 'invalid_type') {
      return 'Realm é obrigatório'
    }
  }

  return (
    <div className={container()}>
      <div className={'mb-1'}>
        <p className={realmSelection()}>Seleção de ambiente</p>
        <p className={choseRealmToAccessApp()}>Escolha o ambiente desejado para acessar o aplicativo.</p>
      </div>
      <Controller
        name='realm'
        control={form.control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <div>
            <Select.Root
              value={value}
              labelExtractor={value => value.realmAlias}
              keyExtractor={value => value.realm}
            >
              <Select.Trigger label='Ambiente' />
              <Select.Popover>
                <Select.Options
                  options={mapRealmAlias(options)}
                  onSelect={onChange}
                />
              </Select.Popover>
            </Select.Root>
            {error && (
              <Hint
                variants={{
                  intent: 'error'
                }}
              >
                <div className={iconHint()}>
                  <IoIosCloseCircleOutline />
                  <p>{getFieldErrorMessage(error)}</p>
                </div>
              </Hint>
            )}
          </div>
        )}
      />

      <div className={containerButton()}>
        <Button
          variants={{ intent: 'primary' }}
          onClick={async () => redirect(form.getValues('realm'))}
        >
          <p>Prosseguir</p>
        </Button>

        <Button
          variants={{ intent: 'secondary', variant: 'text' }}
          onClick={() => setStage(STAGES.EMAIL)}
        >
          <p>Voltar</p>
        </Button>
      </div>
    </div>
  )
}

export default StageRealm
